import { inject, Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import * as actions from './actions';
import { getIndex } from '@state/utils/helper';
import { IndexType } from '@fnModels/algolia/algolia';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';
import { LeapApiService } from '../../../api-repos/leap/leap-api.service';
import { AlgoliaHit } from '@state/utils/models';
import { AlgoliaMortgageBrokerage } from '@fnModels/algolia/broker';

export type BrokerageSearchStateModel = AlgoliaBaseState<unknown>;
@State<BrokerageSearchStateModel>({
	name: 'brokerageSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class BrokerageSearchState extends AlgoliaSearchState<BrokerageSearchStateModel> {
	private leapApiService = inject(LeapApiService);
	protected indexName = getIndex(IndexType.BROKERAGES);

	@Selector([BrokerageSearchState])
	static getList(state: BrokerageSearchStateModel): unknown[] {
		return state?.items;
	}

	@Selector([BrokerageSearchState])
	static getSearching(state: BrokerageSearchStateModel): boolean {
		return state?.searching;
	}

	@Action(actions.Reset)
	reset({ patchState }: StateContext<BrokerageSearchStateModel>): void {
		patchState({ searching: false, success: false, error: null, items: [] });
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<BrokerageSearchStateModel>,
		{ searchTerm }: actions.Search,
	): Promise<void> {
		// if (this.store.selectSnapshot(SelectedMatter.isLeapMatter)) {
		// 	await this.brokerageSearchLeap(ctx, searchTerm);
		// } else {
		await this.algoliaSearchHandler(ctx, searchTerm);
		//}
	}

	async brokerageSearchLeap(
		{ patchState }: StateContext<BrokerageSearchStateModel>,
		searchTerm: string,
	) {
		patchState({
			searching: true,
			searchTerm,
			success: false,
			error: null,
			items: [],
		});
		if (!searchTerm) return;
		const results = await this.leapApiService
			.searchBrokerages(searchTerm)
			.toPromise();

		patchState({
			success: true,
			searching: false,
			items: results as AlgoliaHit<AlgoliaMortgageBrokerage>[],
		});
	}
}
